import gql from 'graphql-tag'

export const getTaxQuery = gql`
  query getTaxes(
    $country: String!
    $shipAddress: NetsuiteTaxAddress!
    $cart: [SimpleCartInput]!
    $currency: String
  ) {
    taxes: getTaxesByAddress(
      shipAddress: $shipAddress
      countrySubsidiary: $country
    ) {
      total
      rate
      ratePst: rate_pst
      rateGst: rate_gst
      internalId
      countrySub
    }

    shipping: getShippingByCountry(country: $country, cart: $cart, printOrder: true, currency: $currency) {
      id
      total
      internalId
      carrier
    }
  }
`

export const getTaxOnlyQuery = gql`
  query getTaxes(
    $country: String!
    $shipAddress: NetsuiteTaxAddress!
  ) {
    taxes: getTaxesByAddress(
      shipAddress: $shipAddress
      countrySubsidiary: $country
    ) {
      total
      rate
      ratePst: rate_pst
      rateGst: rate_gst
      internalId
      countrySub
    }
  }
`

export const isScaPaymentQuery = gql`
  query isScaPayment($code: String!) {
    subsidiarySCA: isScaPayment(code: $code) {
      subsidiary
      sca
    }
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/CheckoutPrint/CheckoutSummary/data.ts